export default {
  newDesign: true,
  parameters: {
    landing_id: "LatQuScoMt",
    segment: 14,
    success_page: "success_long",
  },
  title:
    "Responde a estas preguntas y recibe una clase gratuita para tu hijo | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde a estas preguntas y recibe una clase gratuita para tu hijo/a",
    subtitle:
      "✏️ Para niños de 8 a 17 años<br>💙 Ya elegido por más de 100.000 padres",
    image: {
      url: "/welcome/latam_scoring_google_and_meta_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_scoring_google_and_meta_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Empezar →",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    2: {
      question: "¿Qué le gusta hacer a tu hijo en su tiempo libre?",
      answers: [
        "Jugar deportes o juegos al aire libre 🏐",
        "Leer libros o cómics 📕",
        "Ver TV, YouTube o jugar videojuegos 🎮",
        "Otro 😊",
      ],
    },
    3: {
      question: "¿Cómo se siente tu hijo con respecto al aprendizaje en línea?",
      answers: [
        "Les encanta y lo encuentran interesante 💻",
        "Prefieren el aprendizaje presencial 🎓",
        "Le cuesta mantener la concentración 😵‍💫",
        "Nunca han intentado aprender en línea 🙅‍♂️",
      ],
    },
    4: {
      question: "¿Cómo actúa tu hijo cuando trabaja en grupo?",
      answers: [
        "Le gusta colaborar 🤝",
        "Prefiere liderar 🦸",
        "Trabaja independientemente, pero contribuye ✔️",
        "Se siente tímido o incómodo 🥶",
      ],
    },
    5: {
      question: "¿En qué tipo de escuela estudia tu hijo?",
      answers: [
        "Pública 🍎",
        "Privada 🏫",
        "Internacional/Bilingüe 🌎",
        "Homeschooling 🏡",
      ],
    },
    6: {
      question: "¿Qué le gusta más a tu hijo en la escuela?",
      answers: [
        "Ciencias o matemáticas 🔬",
        "Arte, música o actividades creativas 👩‍🎨",
        "Educación física o deportes ⛹️‍♀️",
        "Otro 😊",
      ],
    },
    7: {
      question: "¿Cuál es el nivel educativo más alto en tu familia?",
      answers: [
        "Maestría o superior 🎓",
        "Licenciatura 👩‍🎓",
        "Secundaria 🏫",
        "Preparatoria 📚",
      ],
    },
    8: {
      question:
        "¿Cuántos dispositivos (computadora, teléfono o tablet) puede usar tu hijo en casa?",
      answers: ["0 – No dispone", "1 dispositivo", "2 o más dispositivos"],
    },
    9: {
      question: "¿Qué tipo de acceso a internet tienen en casa?",
      answers: [
        "Internet de alta velocidad (fibra)",
        {
          answer: "Internet básico (ADSL)",
          redirectToBackupForm: true,
        },
        {
          answer: "Solo datos móviles",
          redirectToBackupForm: true,
        },
        {
          answer: "No tenemos acceso confiable",
          redirectToBackupForm: true,
        },
      ],
    },
    10: {
      question:
        "¿Cuándo quiere que tu hijo empiece sus clases de programación?",
      answers: [
        "Esta semana",
        {
          answer: "En 2-4 semanas",
          redirectToBackupForm: true,
        },
        {
          answer: "En 1-3 meses",
          redirectToBackupForm: true,
        },
        {
          answer: "Solo explorando",
          redirectToBackupForm: true,
        },
      ],
    },
    11: {
      question:
        "¿Tienes computadora o portátil para que tu hijo pueda estudiar?",
      answers: [
        "Si 💻",
        {
          answer: "No 🙁",
          stopAnswer: true,
        },
      ],
    },
    12: {
      dynamicTypeInfo: [
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 8,
              answer: "1 dispositivo",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 8,
              answer: "1 dispositivo",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
            {
              step: 10,
              answer: "Esta semana",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 8,
              answer: "1 dispositivo",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
            {
              step: 8,
              answer: "1 dispositivo",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
            {
              step: 8,
              answer: "1 dispositivo",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
            {
              step: 8,
              answer: "2 o más dispositivos",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Internacional/Bilingüe 🌎",
            },
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 5,
              answer: "Privada 🏫",
            },
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 7,
              answer: "Maestría o superior 🎓",
            },
            {
              step: 8,
              answer: "1 dispositivo",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          condition: [
            {
              step: 6,
              answer: "Ciencias o matemáticas 🔬",
            },
            {
              step: 7,
              answer: "Licenciatura 👩‍🎓",
            },
          ],
          data: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
              "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "🗓️ Agendar clase gratis",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noButton",
            title: "¡Gracias por confiar en nuestra plataforma educativa!",
            subtitle:
              "Lamentablemente, en este momento no podemos registrarte para las clases. Si tienes alguna pregunta, puedes escribirnos a nuestro correo electrónico: social@kodland.org.<br>¡Esperamos poder ayudarte pronto!",
          },
        },
      ],
    },
    13: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Casi terminamos 🔥",
    },
    14: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    15: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    16: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    17: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
